/**
 * Dodaje ili uklanja klasu 'hasText' s elementa forme, koja zacrni tekst polja.
 *
 * @param {string} selectorId Identifikator elementa (bez prefiksa #)
 */
function toggleHasTextClassToFormElement(selectorId) {
    const element = document.getElementById(selectorId);
    if (element.value !== '') {
        element.classList.add('hasText');
    } else {
        element.classList.remove('hasText');
    }
}

export default function inputWithPlaceholder(selectorId) {
    toggleHasTextClassToFormElement(selectorId);
    document.getElementById(selectorId).addEventListener('change', () => {
        toggleHasTextClassToFormElement(selectorId);
    });
}
